/**
 * Éclat Luxury Jewelry - Predictive Live Search Engine
 */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('PredictiveSearchModal');
  if (!modal) return;

  const openTriggers = document.querySelectorAll('[data-open-predictive-search], a[href*="/search"]');
  const closeTriggers = modal.querySelectorAll('[data-close-predictive-search]');
  const input = modal.querySelector('[data-predictive-search-input]');
  const clearBtn = modal.querySelector('[data-clear-search]');
  const popularContainer = modal.querySelector('[data-popular-searches]');
  const resultsContainer = modal.querySelector('[data-predictive-search-results]');
  const resultsGrid = modal.querySelector('.predictive-search-results__grid');
  const loadingIndicator = modal.querySelector('[data-search-loading]');
  const viewAllLink = modal.querySelector('[data-search-view-all-link]');

  let debounceTimer = null;

  // Mock catalog for offline/preview mode fallback
  const fallbackCatalog = [
    {
      title: 'Aurelia Solitaire Diamond Ring',
      url: '/products/aurelia-solitaire-diamond-ring',
      price: '$2,450.00',
      image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400&q=80',
      category: 'Rings / 18k Gold solid vermeil'
    },
    {
      title: 'Solstice Pavé Diamond Huggies',
      url: '/products/solstice-diamond-huggies',
      price: '$1,280.00',
      image: 'https://images.unsplash.com/photo-1630019852942-f89202989a59?w=400&q=80',
      category: 'Earrings / 18k Gold solid vermeil'
    },
    {
      title: 'Lumière Diamond Rivière Tennis Necklace',
      url: '/products/lumiere-riviere-tennis-necklace',
      price: '$5,850.00',
      image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=400&q=80',
      category: 'Necklaces / Diamond Rivière'
    },
    {
      title: 'Celeste Baguette Cut Emerald Ring',
      url: '/products/celeste-emerald-ring',
      price: '$3,150.00',
      image: 'https://images.unsplash.com/photo-1603561591411-07134e71a2a9?w=400&q=80',
      category: 'Rings / Colombian Emerald'
    },
    {
      title: 'Elysian Hand-Sculpted 18K Gold Choker',
      url: '/products/elysian-sculpted-choker',
      price: '$2,850.00',
      image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400&q=80',
      category: 'Necklaces / Gold Vermeil'
    }
  ];

  function openSearch() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 100);
  }

  function closeSearch() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  openTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openSearch();
    });
  });

  closeTriggers.forEach(btn => btn.addEventListener('click', closeSearch));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeSearch();
    }
  });

  modal.querySelectorAll('.search-tag').forEach(tag => {
    tag.addEventListener('click', () => {
      input.value = tag.dataset.searchTerm;
      handleSearch(input.value);
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.style.display = 'none';
      resultsContainer.style.display = 'none';
      popularContainer.style.display = 'block';
      input.focus();
    });
  }

  input.addEventListener('input', () => {
    const query = input.value.trim();
    if (query.length > 0) {
      clearBtn.style.display = 'block';
    } else {
      clearBtn.style.display = 'none';
      resultsContainer.style.display = 'none';
      popularContainer.style.display = 'block';
      return;
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      handleSearch(query);
    }, 280);
  });

  async function handleSearch(query) {
    if (!query) return;
    loadingIndicator.style.display = 'flex';
    resultsContainer.style.display = 'none';
    popularContainer.style.display = 'none';

    if (viewAllLink) {
      viewAllLink.href = `/search?q=${encodeURIComponent(query)}`;
    }

    try {
      const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`;
      const res = await fetch(suggestUrl);
      if (res.ok) {
        const data = await res.json();
        const products = data.resources.results.products;
        if (products && products.length > 0) {
          renderShopifyResults(products);
          return;
        }
      }
      // Fallback local matching
      renderFallbackResults(query);
    } catch (err) {
      renderFallbackResults(query);
    } finally {
      loadingIndicator.style.display = 'none';
      resultsContainer.style.display = 'block';
    }
  }

  function renderShopifyResults(products) {
    resultsGrid.innerHTML = products.map(p => `
      <a href="${p.url}" class="predictive-search-card" onclick="if (window.openPdpProduct) { event.preventDefault(); closeSearch(); window.openPdpProduct('${p.title.replace(/'/g, "\\'")}'); }">
        <div class="search-card__image-wrapper">
          <img src="${p.image || p.featured_image?.url || ''}" alt="${p.title}" loading="lazy">
        </div>
        <div class="search-card__details">
          <span class="search-card__category">${p.vendor || 'Atelier Collection'}</span>
          <h4 class="search-card__title">${p.title}</h4>
          <span class="search-card__price">${p.price}</span>
        </div>
      </a>
    `).join('');
  }

  function renderFallbackResults(query) {
    const qLower = query.toLowerCase();
    const matches = fallbackCatalog.filter(item => 
      item.title.toLowerCase().includes(qLower) || 
      item.category.toLowerCase().includes(qLower)
    );

    if (matches.length === 0) {
      resultsGrid.innerHTML = `
        <div style="grid-column: 1 / -1; text-align: center; padding: 2rem 0; color: var(--color-text-secondary);">
          <p style="font-family: var(--font-serif); font-size: 1.25rem; margin-bottom: 0.5rem;">No atelier creations found for "${query}"</p>
          <p style="font-size: 0.8125rem;">Try searching for "Solitaire", "Diamond", "Gold", or explore all collections.</p>
        </div>
      `;
    } else {
      resultsGrid.innerHTML = matches.map(p => `
        <a href="${p.url}" class="predictive-search-card" onclick="if (window.openPdpProduct) { event.preventDefault(); closeSearch(); window.openPdpProduct('${p.title.replace(/'/g, "\\'")}'); }">
          <div class="search-card__image-wrapper">
            <img src="${p.image}" alt="${p.title}" loading="lazy">
          </div>
          <div class="search-card__details">
            <span class="search-card__category">${p.category}</span>
            <h4 class="search-card__title">${p.title}</h4>
            <span class="search-card__price">${p.price}</span>
          </div>
        </a>
      `).join('');
    }
  }
});
